import { EmailSearchFilter } from "../../managers";
import { mapFolderToLabel } from "../../managers/dataManager/google/types/const";
import { logger } from "../logs/core";
import { LOGS } from "../logs/logConfig";

export function buildGoogleQueryFromFilterObject(
    filter: EmailSearchFilter,
): string {
    const params = new URLSearchParams();

    // Construction de la query Gmail
    const queryParts: string[] = [];

    // Recherche textuelle générale
    if (filter.searchText && filter.searchText.length > 0) {
        // Gmail utilise un format de recherche plus simple
        const searchTerms = filter.searchText.join(" ");
        queryParts.push(searchTerms);
    }

    // Filtres de date
    if (filter.dateRange) {
        const startDate = new Date(filter.dateRange.start);
        const endDate = new Date(filter.dateRange.end);

        // Convertir en timestamp Unix (secondes)
        const startTimestamp = Math.floor(startDate.getTime() / 1000);
        const endTimestamp = Math.floor(endDate.getTime() / 1000);

        queryParts.push(`after:${startTimestamp}`);
        queryParts.push(`before:${endTimestamp}`);
    }

    if (filter.folder) {
        const gmailLabel =
            mapFolderToLabel[filter.folder.toLowerCase()] || filter.folder;
        queryParts.push(`in:${gmailLabel.toLowerCase()}`);
    } else {
        // Par défaut, chercher dans INBOX
        queryParts.push("in:inbox");
    }

    // Assemblage de la query finale
    if (queryParts.length > 0) {
        params.append("q", queryParts.join(" "));
    }

    params.append("maxResults", "100"); // Valeur par défaut

    logger.info([LOGS.GoogleManager], `Query params : ${params.toString()}`);

    return params.toString();
}
